// extracted by mini-css-extract-plugin
module.exports = {"container":"AppLoading_container__nODWH","loading":"AppLoading_loading__1nNS4"};